import { render } from "./ApiLogsView.vue?vue&type=template&id=f7672fa6&scoped=true"
import script from "./ApiLogsView.vue?vue&type=script&lang=js"
export * from "./ApiLogsView.vue?vue&type=script&lang=js"

import "./ApiLogsView.vue?vue&type=style&index=0&id=f7672fa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7672fa6"]])

export default __exports__